import React, { useEffect } from 'react';
import {
  CircularProgress,
} from '@material-ui/core';

import {
  removeCookie,
} from '../../utils/cookies';

export default function () {
  useEffect(() => {
    removeCookie('boxToken');
    removeCookie('cognitoToken');
    window.location.pathname = '/';
  }, []);
  return (
    <div className="tabs justify-center fill items-center" style={{ height: '100vh' }}>
      <CircularProgress style={{ width: 100, height: 100 }} />
      <p className="margin-top-30">Logging out...</p>
    </div>
  );
}
